import { render, staticRenderFns } from "./RevenueManagerSetupActionForm.vue?vue&type=template&id=0197ac7f&scoped=true&"
import script from "./RevenueManagerSetupActionForm.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197ac7f",
  null
  
)

export default component.exports